import { createSelector } from 'reselect';

const getError = state => state.error;
const ErrorSelector = loadActionType => params =>
  createSelector(getError, error => error[`${loadActionType}${params ? `_${JSON.stringify(params)}` : ''}`]);
export default ErrorSelector;
